/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


const accordions = document.querySelectorAll(".product-meta_accordion");

if (accordions.length > 0) {
  accordions[0].classList.add("first-accordion");
  accordions[accordions.length - 1].classList.add("last-accordion");
}


// ALL SLICK SLIDER SCRIPT
$(document).ready(function(){
  $('.solution-product-items_list1').slick({
    slidesToShow: 3,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: "unslick"
      }
    ]
  });
  var $carousel = $('.solution-product-items_list1').flickity({
    contain: true,
  });
  $('.category-items_list').slick({
    slidesToShow: 3,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: "unslick"
      }
    ]
  });
  $('.customer-review_items-list').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: false
  });
});

$(document).ready(function(){
  $('body').on('click','.link_redirection', function(){
    window.location.href = $(this).attr('href');
  });
  $('body').on('change','.fbt-item-checkbox', function(){
    var fbt_total_price = 0;
    var fbt_total_copmpare_price = 0;

    var product_handle = $("body").attr("product-handle");
    var selected_variant_id = parseInt($('.fbt-item:first').find('.fbt-item-checkbox').attr('data-vid'));

    $(".fbt-item:has( .fbt-item-checkbox:checked)").each(function() {        
      fbt_total_price = fbt_total_price + parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-price'))
      fbt_total_copmpare_price = fbt_total_copmpare_price + parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-compare-price'))
    });

    var fbt_total_discounted_price = fbt_total_copmpare_price - fbt_total_price;
    console.log('price',fbt_total_price,fbt_total_copmpare_price,fbt_total_discounted_price)

    $(this).closest('.fbt-main').find('.fbt-total-summary_item-compare_price').html(formatMoney(fbt_total_copmpare_price));
    $(this).closest('.fbt-main').find('.fbt-total-summary_item-final-price').html(formatMoney(fbt_total_price)); 
    
    if(fbt_total_copmpare_price > fbt_total_price){
      $(this).closest('.fbt-main').find('.fbt-total-summary_discount-item').show();
      $(this).closest('.fbt-main').find('.fbt-total-summary_item-discount').html(`-${formatMoney(fbt_total_discounted_price)}`);   
    }else{
      $(this).closest('.fbt-main').find('.fbt-total-summary_discount-item').hide();
    }

    if($('.fbt-item-checkbox:checked').length == 0){
      console.log($('.fbt-item-checkbox:checked').length);
      $(".fbt-product-bundle__cta").attr("disabled",true)
    }else{
      $(".fbt-product-bundle__cta").removeAttr("disabled");
    }
    if($('.fbt-item-checkbox:checked').length == 3){
      $('.fbt-item-checkbox').removeAttr('disabled');
      $('.fbt-offer_info[selected-product="3"]').show();
      $('.fbt-offer_info[selected-product="2"]').hide();
    }else{
      $('.fbt-item-checkbox:checked').attr('disabled', '');
      $('.fbt-offer_info[selected-product="3"]').hide();
      $('.fbt-offer_info[selected-product="2"]').show();
    }
  });
  
  $('body').on('click','.fbt-product-bundle__cta', function(){    
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var items = [];
    $(this).closest('.fbt-main').find('.fbt-item-checkbox:checked').each(function(i,v){
       var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });          
    });    
    
    var data = {items};
    console.log('data',data)
   
    if(items.length > 0){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: {items},
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          console.log('Free Gift Error',response.description);
          _this.removeAttr("disabled");
          _this.attr("aria-busy", "false");  
        },
        success: function() {
          console.log('success');
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
          })); 
          _this.removeAttr("disabled");
          _this.attr("aria-busy", "false");  
          document.getElementById('mini-cart').open = true;
        }
      });
    } 
  });
});

$(document).ready(function(){
  $('.solution-product-item_front-wrapper').click(function(e){
    e.preventDefault();
    $('.solution-product-item').removeClass('active');
    $(this).parents('.solution-product-item').addClass('active');
  });
  $('.solution-product-item_close').click(function(e){
    e.preventDefault();
    $('.solution-product-item').removeClass('active');
  });

  $("body").on("click", ".product-meta_best_buy-copy_code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute

    if (!text) return; // prevent copying empty

    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });
  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this);
    var text = copy_text.attr("code"); // <- get value from custom "code" attribute

    if (!text) return; // prevent copying empty

    // Use modern clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        copy_text.attr("copied", "copied");
        setTimeout(function () {
          copy_text.removeAttr("copied");
        }, 1000);
      });
    } else {
      // Fallback for older browsers
      var $temp = $("<input>");
      $("body").append($temp);
      $temp.val(text).select();
      document.execCommand("copy");
      $temp.remove();
      copy_text.attr("copied", "copied");
      setTimeout(function () {
        copy_text.removeAttr("copied");
      }, 1000);
    }
  });

  $('.product-meta_accordion-item_title').click(function() {
    $(this).toggleClass('active');
    $(this).next('.product-meta_accordion-item_content').slideToggle();
  
    // Toggle aria-expanded attribute
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });


  $(".seo-text-read-more-less").click(function (e) {
      e.preventDefault();
      $(".seo-text").toggle();
      $(".seo-text-read-more-less").text() == "Read more" ? $(this).text("Read less") : $(this).text("Read more")
   });

  $('.collection_split-layout-tab_item-wrapper').on('click', function (e) {
    const $this = $(this);
    const targetId = $this.attr('href');

    // Skip if just '#' or if target doesn't exist
    if (targetId.length > 1 && $(targetId).length) {
      e.preventDefault();

      // Remove is-selected from all anchor links
      $('.collection_split-layout-tab_item-wrapper').removeClass('is-selected');
      $this.addClass('is-selected');

      // Set offset for desktop and mobile
      let offsetTop = $(targetId).offset().top;
      let scrollOffset = $(window).width() > 740 ? 70 : 70; // adjust values as needed
  
      // Smooth scroll
      $('html, body').animate({
        scrollTop: offsetTop - scrollOffset
      }, 600);
    }
  });

  $('.video-list_wrapper').each(function () {
    var $section = $(this);
  
    $section.find('.video-list_selected-video_poster').on('click', function (e) {
      e.preventDefault();
  
      var $clickedItem = $(this).closest('.video-list_selected-video_item');
      var $allItems = $section.find('.video-list_selected-video_item');
  
      // Remove classes and pause all videos in this section
      $allItems.removeClass('is-playing is-selected');
      $allItems.find('video').each(function () {
        this.pause();
        this.currentTime = 0;
      });
  
      // Add active classes to clicked item
      $clickedItem.addClass('is-playing is-selected');
  
      // Play the video
      var video = $clickedItem.find('video').get(0);
      if (video) {
        video.play();
      }
    });
  });

  $("body").on("click", ".product-form-size-chart", function (){
    $('html').addClass('lock-all');
    $(this).closest('.product__info').find('.size-chart-modal').attr('open', '');
  })
  $("body").on("click", ".size-chart-modal-button-close, .size-chart-modal-overlay", function (){
    $('html').removeClass('lock-all');
    $(this).parents('.size-chart-modal').removeAttr('open', '');
  })

});

$(document).on('click', '.video-sidebar__link', function (e) {
  e.preventDefault();

  // Find the current video section
  const $section = $(this).closest('.video-list_wrapper');

  // Identify the clicked sidebar item
  const $clickedSidebarItem = $(this).closest('.video-sidebar__item');

  // Get the data-id of the clicked sidebar item
  const targetId = $clickedSidebarItem.data('id'); // e.g. "video-template--...video_R7qUxG"

  // Sidebar item class handling
  $section.find('.video-sidebar__item').removeClass('is-playing');
  $clickedSidebarItem.addClass('is-playing');

  // Remove 'is-selected' from all video items and pause videos
  $section.find('.video-list_selected-video_item').each(function () {
    $(this).removeClass('is-selected');
    const video = $(this).find('video').get(0);
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });

  // Find the video item with the matching ID
  const $targetVideoItem = $section.find('.video-list_selected-video_item#' + targetId);

  // Add 'is-selected' to the matched video item
  $targetVideoItem.addClass('is-selected');
});


// ----------------------------------------------------------

$('.learn-tabs_list-item_link').on('click', function(e) {
  e.preventDefault();
  var target = $(this).attr('href');

  // Set offset based on device width
  var offset = $(window).width() < 740 ? 140 : 190; // mobile: 50px, desktop: 100px

  $('html, body').animate({
    scrollTop: $(target).offset().top - offset
  }, 500);

  $('.learn-tabs_list-item_link').removeClass('is-selected');
  $(this).addClass('is-selected');
});

$(window).on('scroll', function() {
  var scrollPos = $(document).scrollTop();

  // Set offset for scroll highlight too
  var offset = $(window).width() < 740 ? 160 : 200;

  $('.learn-tabs_list-item_link').each(function () {
    var currLink = $(this);
    var refElement = $(currLink.attr('href'));
    if (
      refElement.position().top <= scrollPos + offset && 
      refElement.position().top + refElement.outerHeight() > scrollPos + offset
    ) {
      $('.learn-tabs_list-item_link').removeClass('is-selected');
      currLink.addClass('is-selected');
    }
  });
});

$(window).on('load', function() {
  var offset = $(window).width() < 740 ? 140 : 190;
  var hash = window.location.hash;

  if (hash) {
    var target = $(hash);
    if (target.length) {
      // Use setTimeout to delay scrolling slightly to ensure layout ready
      setTimeout(function() {
        var scrollToPos = target.offset().top - offset;
        if (scrollToPos < 0) scrollToPos = 0; // prevent negative scroll
        $('html, body').scrollTop(scrollToPos);
      }, 50); // delay 50ms
    }
  }
});


